import { render, staticRenderFns } from "./AddToCartDrink.vue?vue&type=template&id=dd67cfe0&scoped=true&"
import script from "./AddToCartDrink.vue?vue&type=script&lang=js&"
export * from "./AddToCartDrink.vue?vue&type=script&lang=js&"
import style0 from "./AddToCartDrink.vue?vue&type=style&index=0&id=dd67cfe0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd67cfe0",
  null
  
)

export default component.exports